import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { RETRY_LINES_ORDERS } from "@/modules/pg/shared/planningTable/reducers/common";
import { REPORT_LOADING_ACTION_NAME } from "@/modules/pg/shared/planningTable/reducers/report";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import type { ActionTypes, ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class RetryButton extends React.Component<Props> {
    onRetry = () => {
        this.props.reduxDispatch({ type: REPORT_LOADING_ACTION_NAME, data: true });
        this.props.reduxDispatch({
            type: RETRY_LINES_ORDERS,
            data: undefined,
        });
    };

    render() {
        return (
            <button className="dropdown-item" onClick={this.onRetry}>
                {translate("common.retry", "Retry")}
            </button>
        );
    }
}

const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({ reduxDispatch: dispatch });

type ReduxProps = ReturnType<typeof mapDispatch>;

export default connect<{}, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(null, mapDispatch)(RetryButton);
